<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="sidebar-title is-size-5 pb-4">Edit Diode</div>
    <form @submit.prevent="submit">
      <c-text-input v-model="data.name" label="Name" placeholder="Pump 10" :error="errors.name"/>
      <c-text-input v-model="data.location" label="Location" placeholder="Facility 10" :error="errors.location"/>
      <diode-user-select v-model="data.user"/>
      <div class="pt-5">
        <button class="button is-primary is-fullwidth">Save</button>
      </div>
    </form>
  </div>
</template>

<script>
import DiodeUserSelect from './diode-user-select';
import api from '@/api';


export default {
  name: 'update-diode-form',
  props: ['diode'],
  components: {
    DiodeUserSelect
  },
  data () {
    return {
      data: {
        name: this.diode.name,
        location: this.diode.location,
        user: this.diode.user ? this.diode.user.id: null,
      },
      errors: {}
    };
  },
  watch: {
    diode() {
      this.data = {
        name: this.diode.name,
        location: this.diode.location,
        user: this.diode.user ? this.diode.user.id: null,
      };
      this.errors = {};
    }
  },
  methods: {
    async submit() {
      try {
        await api.admin.diodes.update(this.diode.serial, this.data);
        this.errors = {};
        this.data = {};
        this.$emit('complete');
      } catch (error) {
        this.handle(error);
      }
    },
    handle(error) {
      const errors = error.data;
      this.errors = {};
      if (errors.user) this.errors.user = 'Please select a valid user.';
      if (errors.name) this.errors.name = 'Please select a valid name.';
      if (errors.location) this.errors.location = 'Please select a valid location.';
    }
  }
};
</script>
